import React from 'react';
import { motion } from 'framer-motion';
type ButtonProps = {
  children: React.ReactNode;
  href: string;
  className?: string;
  fullWidth?: boolean;
  ariaLabel?: string;
};
export function Button({
  children,
  href,
  className = '',
  fullWidth,
  ariaLabel
}: ButtonProps) {
  const external = !href.startsWith('#');
  return <motion.a href={href} aria-label={ariaLabel} target={external ? '_blank' : undefined} rel={external ? 'noopener noreferrer' : undefined} whileHover={{
    scale: 1.015
  }} whileTap={{
    scale: 0.985
  }} transition={{
    duration: 0.14,
    ease: [0.23, 1, 0.32, 1]
  }} className={`inline-flex items-center justify-center rounded-xl bg-primary px-7 py-4 text-center font-display text-base font-bold uppercase tracking-wide text-white shadow-[0_12px_28px_rgba(3,105,161,.28)] transition-colors duration-200 hover:bg-primary-dark focus:outline-none focus:ring-4 focus:ring-accent/30 ${fullWidth ? 'w-full' : ''} ${className}`} data-id="element-277" data-mp="zuu59fsq3l3g">
      {children}
    </motion.a>;
}